import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const api = {
  listModels: () => http.get("/models").then((r) => r.data),
  createSession: () => http.post("/sessions").then((r) => r.data),
  getSession: (id) => http.get(`/sessions/${id}`).then((r) => r.data),
  updateContext: (id, payload) => http.post(`/sessions/${id}/context`, payload).then((r) => r.data),
  uploadDoc: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios
      .post(`${API}/sessions/${id}/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  removeDoc: (id, index) => http.delete(`/sessions/${id}/documents/${index}`).then((r) => r.data),
  begin: (id, model) => http.post(`/sessions/${id}/begin`, { model }).then((r) => r.data),
  chat: (id, message, model) => http.post(`/sessions/${id}/chat`, { message, model }).then((r) => r.data),
  analyze: (id, model, inputs) =>
    http.post(`/sessions/${id}/analyze`, { model, inputs }).then((r) => r.data),
  followup: (id, message, model) => http.post(`/sessions/${id}/followup`, { message, model }).then((r) => r.data),
  newFeature: (id) => http.post(`/sessions/${id}/new-feature`).then((r) => r.data),
};
